import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { CustomButton, PosLayout } from "../../../components";
import { PosInnerPageLayout } from "../../../components/layouts/pos-layout/PosInnerPageLayout";
import { PriceListTable } from "./price-list-table";
import { Colors } from "../../../configs";
import usePricing from "../../../hooks/usePricing";

export const PriceList: React.FC = () => {
  const navigate = useNavigate();
  const { categoryList } = usePricing();

  const [selectedButtonId, setSelectedButtonId] = useState(
    categoryList?.body[0].id
  );

  return (
    <PosLayout>
      <PosInnerPageLayout title="Basic Pricing">
        <Box
          sx={{
            display: "flex",
            gap: "4rem",
            backgroundColor: Colors.WHITE,
            padding: "2rem",
            borderRadius: "0.7142857142857143rem",
            margin: "0 auto",
            maxWidth: "130rem",
          }}
        >
          <Box
            sx={{
              width: "57rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: Colors.MAIN_GRAY,
                fontSize: "2.285714285714286rem",
                fontWeight: "bold",
                marginTop: "1rem",
              }}
            >
              Select Category
            </Typography>
            <Box
              sx={{
                backgroundColor: Colors.BACKSHADE_GRAY,
                padding: "1rem",
                borderRadius: "0.71rem",
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "0.4rem",
                width: "59rem",
                minHeight: "31.07142857142857rem",
                maxHeight: "54.07142857142857rem",
              }}
            >
              {categoryList?.body.map((button) => (
                <CustomButton
                  key={button.id}
                  variant="contained"
                  sx={{
                    width: "calc(99% - 0.3rem)",
                    height: "6.428571428571429rem",
                    boxShadow: "none",
                    borderRadius: "0.71rem",
                    fontSize: "1.857142857142857rem",
                    textTransform: "capitalize",
                    lineHeight: "2.34357143rem",
                    marginLeft: "0.4rem",
                    backgroundColor:
                      selectedButtonId === button.id
                        ? Colors.PRIMARY
                        : Colors.SECONDARY,
                    color: Colors.WHITE,
                    "&:hover": {
                      backgroundColor:
                        selectedButtonId === button.id
                          ? Colors.PRIMARY
                          : Colors.SECONDARY,
                    },
                  }}
                  onClick={() => setSelectedButtonId(button.id)}
                >
                  {button.categoryName}
                </CustomButton>
              ))}
            </Box>
          </Box>

          <Box
            sx={{
              width: "57rem",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: Colors.MAIN_GRAY,
                fontSize: "2.285714285714286rem",
                fontWeight: "bold",
                marginTop: "0.4rem",
              }}
            >
              Item and Basic Price
            </Typography>
            <Box
              sx={{
                backgroundColor: Colors.BACKSHADE_GRAY,
                padding: "1rem",
                borderRadius: "0.7142857142857143rem",
                height: "43.12857142857143rem",
                width: "57rem",
              }}
            >
              <PriceListTable service={selectedButtonId ?? 0} />
            </Box>

            <Box
              sx={{
                backgroundColor: Colors.BACKSHADE_GRAY,
                padding: "1rem",
                borderRadius: "0.7142857142857143rem",
                height: "10.07142857142857rem",
                width: "57rem",
                textAlign: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: Colors.MAIN_GRAY,
                  fontSize: "1.714285714285714rem",
                  fontWeight: "bold",
                  marginTop: "1.5rem",
                  justifyContent: "center",
                  paddingLeft: "1.5rem",
                  paddingRight: "1.5rem",
                }}
              >
                All above pricing are base prices and additional charge may be
                added for proper care of each garment depending on fabric,
                cleaning & pressing method and handling procedures.
              </Typography>
            </Box>
          </Box>
        </Box>
      </PosInnerPageLayout>
    </PosLayout>
  );
};

export default PriceList;
